<template>
    <div class="wrap">
        <!-- 标题 -->
        <!-- loading页面 -->
        <ModuleReload :state="reloadState" :click="clickReload"/>
        <!-- cell-wrap容器 -->
        <div v-if="checkData(pageData)">
            <!-- cell内容 -->
            <slot :list="pageData"></slot>
        </div>
        <div v-if="!checkData(pageData) && emptyTitle.length && reloadState === -1" class="wrapper">
          <p class="text">{{emptyTitle}}</p>
        </div>
        <!-- 更多 -->
        <ModuleButton v-if="moreTitle.length > 0 && checkData(pageData) && showMore(pageData)"
        :click="clickMore" :value="moreTitle"/>
        <!-- 间隔空隙 -->
        <!-- <FundMargin v-if="moreTitle"/> -->
    </div>
</template>

<script>

import NativeMsg from '@/base/NativeMsg';
import ModuleButton from '@/components/ModuleButton.vue';
import ModuleReload from '@/components/ModuleReload.vue';

export default {
  name: 'FundModule',
  components: {
    ModuleButton,
    ModuleReload,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    desc: {
      type: String,
      default: '',
    },
    rightBtnDesc: {
      type: String,
      default: '',
    },
    rightBtnEvent: {
      type: Function,
      default: () => {
      },
    },
    moreTitle: {
      type: String,
      default: '',
    },
    emptyTitle: {
      type: String,
      default: '',
    },
    fetchCache: {
      type: Function,
      default: () => null,
    },
    fetchRequest: {
      type: Function,
      default: () => null,
    },
    checkData: {
      type: Function,
      default: () => false,
    },
    nowrightArrow: {
      type: Boolean,
    },
    showMore: {
      type: Function,
      default: () => true,
    },
    isMainQueryError: {
      type: Function,
      default: () => false,
    },
    moreEvent: {
      type: Function,
      default: () => {
      },
    },
    slotNextTick: {
      type: Function,
      default: () => {
      },
    },
  },
  data() {
    return {
      pageData: [],
      reloadState: 0,
      mainStateErr: false,
    };
  },
  computed: {},
  created() {
  },
  mounted() {
    // this.start();
  },
  methods: {
    start() {
      this.showLogic();
    },
    cache() {
      // -1 隐藏   0 信息加载中...   1 加载失败, 点击重试

      // 获取缓存数据
      const cacheData = this.fetchCache();
      // console.log(`✅cache--${this.title}`);
      if (!this.checkData(cacheData)) {
        return;
      }
      // console.log(`✅cache-have--${this.title}`);
      // console.log(`no checkData--${this.title}`);
      this.reloadState = -1;
      this.pageData = cacheData;
      this.$nextTick(() => {
        this.slotNextTick(this.pageData);
      });
    },
    showMainError() {
      if (this.reloadState === 0) {
        this.reloadState = 1;
        this.mainStateErr = true;
      }
    },
    showLogic() {
      // -1 隐藏   0 信息加载中...   1 加载失败, 点击重试
      // 获取缓存数据
      const cacheData = this.fetchCache();
      // console.log(`✅cache--${this.title}`);
      if (!this.checkData(cacheData)) {
        // console.log(`✅cache-no-have--${this.title}`);
        this.reloadState = 0;
        this.request().then((res) => {
          // console.log(`✅request-success--${this.title}`);
          this.reloadState = -1;
          this.pageData = res;
          this.$nextTick(() => {
            this.slotNextTick(this.pageData);
          });
        }).catch(() => {
          // console.log(`✅request-fail--${this.title}`);
          this.reloadState = 1;
        });
        return;
      }
      // console.log(`✅cache-have--${this.title}`);
      // console.log(`no checkData--${this.title}`);
      this.reloadState = -1;
      this.pageData = cacheData;
      this.$nextTick(() => {
        this.slotNextTick(this.pageData);
      });
      this.request().then((res) => {
        // console.log(`✅request-success--${this.title}`);
        // res.push(cacheData[0]);
        // res.push(cacheData[0]);
        this.pageData = res;
      }).catch(() => {
        // console.log(`✅request-fail--${this.title}`);
      });
    },
    request() {
      return new Promise((resolve, reject) => {
        this.fetchRequest().then((res) => {
          resolve((res && Object.prototype.toString.call(res) === '[object Array]') ? res : []);
        }).catch(() => {
          reject();
        });
      });
    },
    clickReload() {
      if (this.mainStateErr) {
        NativeMsg.post(JSON.stringify({ key: 'reflash', value: { v: 'start' } }));
        return;
      }
      this.showLogic();
    },
    clickMore() {
      this.moreEvent();
    },
  },
};
</script>

<style scoped lang="less">
.wrap{
  background-color: #ffffff;
}
.cell-wrap {
  background-color: #ffffff;
}
.wrapper {
    background-color: #ffffff;
    height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.text {
    font-family: PingFangSC-Regular;
    font-size: 30px;
    color: #999999;
    text-align: center;
}
</style>
